import { useSelector } from "react-redux";

import __ from "web/Layout/Translations";

import dateFormatterWithDots from "web/utils/data/parser/dateAndTime/dateFormatterWithDots";

import styles from "./windowDatesInfo.scss";

const WindowDatesInfo = () => {
  const { config } = useSelector((state) => state.subscriptionQuote);
  const { chooseUmsSubscriptionsTo, startUmsSubscriptionsFrom } = config || {};

  const finalDates = {
    fullDateToDate: dateFormatterWithDots(chooseUmsSubscriptionsTo),
    fullDateFromDate: dateFormatterWithDots(startUmsSubscriptionsFrom)
  }

  return (
    <section className={styles.root}>
      <p>
        {__("Wybieraj i zmieniaj swoje abonamenty do")}:
        <span className={styles.highlight}>{finalDates?.fullDateToDate}</span>
        {__("aby zostać nimi objętym od")}:
        <span className={styles.highlight}>{finalDates?.fullDateFromDate}</span>
      </p>
    </section>
  );
};

export default WindowDatesInfo;
